<template>
	<div>
		<div class="padding-10">
			<div class="mb-3">
				<label class="title-color title-font">Automations </label> 
				<!-- <img class="mb-1 ml-3 mr-3" height="30" src="../../assets/images/icons/solid/search_icon.svg"/> -->
				<!-- <input class="background-none border-none height-40 width-60 input-font" type="text"/> -->
				<button @click="openAutomationCreate()" class="button large-button float-right">New</button>
			</div>
			<div v-if="automation_list.length>0">
			<div  v-for="(elem,index) in automation_list" :key="elem.id" class="flex align-center background-white mt-3 mb-3">
				<!-- <div class="mr-3">
						<toggle-button 
							@change="statusChanged(elem, index)"
							v-model="elem.is_active ? true : false" class="mt-1 ml-2"
							:labels="false" :width="50"
							:color="{ checked : 'rgba(117, 187, 67, 1)', unchecked : 'rgba(215, 215, 215, 1)', disabled : '#CCCCCC' }" :sync="true"
						/>
				</div> -->
				<div class="flex list-border">
						<div class="padding-12 child-1">
							<div class="automation-title mb-2">{{elem.name}}</div>
							<div class="automation-description mb-2">
								<span v-html="elem.sentence">{{elem.sentence}}</span>
								<!-- <span>All employees that their </span>
								<span>disciplin is HHA </span>
								<span>and their </span>
								<span class="description-key-color">Location is NYC </span>
								<br>
								<span>Will be added to the Programs: </span>
								<span> AtenasCare 2021 Q3</span>
								<span class="description-key-color"> AtenasCare 2021 Q4</span> -->
							</div>
							<div class="footer-details">
								<span class="mr-3">Creator Name: {{elem.created_by}}</span>
								<span class="mr-3">Date Created: {{elem.created_at}}</span>
								<span>Last Change: {{elem.updated_at}}</span>
							</div>
						</div>
						<div class="child-2">

							<div class="trigger-hidden-content">
								<span class="button">
									<img width="15" src="../../assets/images/icons/solid/ellipsis-h_white.svg">
								</span>
									<div class="trigger-content">
									
									<a class="cursor-pointer" @click="editAutomation(elem.id)">
										<img width="16" class="mr-2" src="../../assets/images/icons/solid/automation_pen.svg"/> Edit
									</a>
									<a class="cursor-pointer" @click="openAutomationHistory(elem, 0)">
										<img width="16" class="mr-2" src="../../assets/images/icons/solid/show_history.svg"/> Actions History
										
									</a>
									
									</div>
							</div>
							
							
						</div>
						<div class="child-3">
							<div class="vertical-line"></div>

							
						</div>
						<div class="child-4">
							<div class="">
								<toggle-button 
									@change="statusChanged(elem, index)"
									v-model="elem.is_active ? true : false" class="mt-1 ml-2"
									:labels="false" :width="50"
									:color="{ checked : 'rgba(117, 187, 67, 1)', unchecked : 'rgba(215, 215, 215, 1)', disabled : '#CCCCCC' }" :sync="true"
								/>
							</div>
						</div>

				</div>
			</div>
			</div>
			<div v-else class="list-border background-white mt-3 mb-3">
				<h5 class="text-align-center">No automations have been created yet</h5>
			</div>
		</div>
		<automation-history v-if="show_history && current_automation_history" :automation="selected_automation" :automation_history="current_automation_history" @closeAutomationHistory="closeAutomationHistory" @setPageAutomationHistory="setPageAutomationHistory"></automation-history>
	
	</div>
</template>
<script>
import automationMixin from './automationMixin'
import automationHistory from './automationSharedView/automationHistory.vue'
export default {
	components : {
		automationHistory
	},
	mixins : [automationMixin],
	data : function(){
		return{
			toggle_model: true,
			automation_list:'',
			user_role: this.$store.getters.getRole,
			show_history: false,
			selected_automation: null,
			current_automation_history:null,

		}
	},
	created : function(){
		this.getAutomationList()
	},
	methods : {
		getAutomationList(){
			if(this.user_role == 'csm' || this.user_role == 'admin'){
				var params = {}
				params.filters = {
					organization_id : this.id ,
					page_loading: false
				}
			}

			this.$store.dispatch('getAutomationRulesList', params).then((res) => {
				this.automation_list = res.data.data
			}).catch((error) => {
				console.log(error);
			});

		},
		statusChanged(elem, index){
			let params = {
				id: elem.id,
				is_active: elem.is_active ? '0':'1'
			}
			if(this.user_role ==  'csm' || this.user_role == 'admin'){
				params.organization_id = this.id
			}
			this.$store.dispatch('editAutomationRuleStatus', params).then((res) => {
				this.getAutomationList()
				
			}).catch((error) => {
				console.log(error);
			});

		},
		openAutomationCreate(){
			this.$emit('openAutomationCreate', null)
		},
		editAutomation(automation_id){
			this.$emit('openAutomationCreate', automation_id)
		},
		openAutomationHistory(automation, page){
			var params = {
				id : automation.id,
				filters: {
					page_loading: false,
					per_page:20,
					page:page || 1
				}
			}
			this.$store.dispatch('openAutomationHistory', params).then((res) => {
				this.current_automation_history = res.data
			}).catch((error) => {
				console.log(error);
			});
			this.show_history = true
			this.selected_automation = automation
		},
		closeAutomationHistory(){
			this.current_automation_history = []
			this.show_history = false
			this.selected_automation = null
			//this.automation_history_page = 0
		},
		setPageAutomationHistory(forward, page){
			//forward ? this.automation_history_page++ : this.automation_history_page--
			this.openAutomationHistory(this.selected_automation, page)
		}
		
	}
	
}
</script>
<style src="./automation.css">

</style>


// WEBPACK FOOTER //
// src/components/automation/AutomationList.vue